import { Component, Injector } from '@angular/core';
import { TotalVehicleNumberService, TrackingVehicleNumberService, ProgramDetailsBodyService } from '../../ve.service';
import { BaseGridComponent } from '../base-grid/base-grid.component';
import { CgpConfirmationDialogService } from '../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { Validators } from '@angular/forms';
import { FilterableService } from '../../../../shared/filterable-service';

@Component({
  selector: 'app-total-vehicle-number',
  templateUrl: '../base-grid/base-grid.component.html',
})
export class TotalVehicleNumberComponent extends BaseGridComponent {
  public descMaxLength: number = null;
  private readonly trackingVehicleNumberService: TrackingVehicleNumberService;
  private readonly trackingVehService = new FilterableService();
  private readonly bodyProgramService: ProgramDetailsBodyService;
  private readonly programService = new FilterableService();

  constructor(
    cgpConfirmationDialogService: CgpConfirmationDialogService,
    cgpSnackbarService: CgpSnackbarService,
    service: TotalVehicleNumberService,
    injector: Injector,
  ) {
    super(cgpConfirmationDialogService, cgpSnackbarService, service, injector);
    this.trackingVehicleNumberService = injector.get(TrackingVehicleNumberService);
    this.bodyProgramService = injector.get(ProgramDetailsBodyService);

    this.descMaxLength = 30;
    this.appCardTitle = 'Total Vehicle Numbers';
    this.path = '/?activeOnly=false';

    this.columns = [
      {
        field: 'Description',
        title: 'Total Vehicle Number',
      },
      {
        field: 'TrackingVehiclesNumbers',
        title: 'Tracking Vehicle Numbers',
        type: 'multiselect',
        service: this.trackingVehService,
        textField: 'Description',
        valueField: 'Id',
        name: 'TrackingVehicleIds',
        refreshSecondaryData: this.populateTrackingVehiclesNumbers,
      },
      {
        field: 'ProgramCode',
        title: 'Program',
        type: 'dropdown',
        service: this.programService,
        textField: 'ProgramCode',
        valueField: 'ProgramId',
        name: 'ProgramId',
        refreshSecondaryData: this.populateProgramList
      },
      {
        field: 'IsActive',
        title: 'Active',
        editor: 'boolean',
        filter: 'boolean'
      },
    ];

    this.editForm = this.formBuilder.group({
      Id: [],
      Description: ['', Validators.required],
      ProgramId: ['',  Validators.required],
      ProgramCode: [],
      TrackingVehiclesNumbers: [],
      TrackingVehicleIds: ['',  Validators.required],
      IsActive: [],
      AuditDto: []
    });
  }

  populateTrackingVehiclesNumbers(dataItem: any) {
    dataItem.trackingVehicleNumberService.read('?activeOnly=true')
      .then(result => {
        if (result.length > 0) {
          result.sort((a, b) => a.Description.localeCompare(b.Description));
        }
        dataItem.trackingVehService.next(result);
      });
  }

  populateProgramList(dataItem: any) {
    dataItem.bodyProgramService.read('?activeOnly=true')
    .then(result => {
      if (result.length > 0) {
        result.sort((a, b) => a.ProgramCode.localeCompare(b.ProgramCode));
      }
      dataItem.programService.next(result);
    });
  }
}
